var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.reportLoaded)?_c('c3-chart',{attrs:{"height":300,"data":_vm.chartData,"config":_vm.chartConfig,"type":"bar"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }